import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 通过工作单UUID，获取舱单数据格式化
export function getManifestInfosByJobUuid(data) {
  return request({
    url: URL.seaExport.getManifestInfosByJobUuid,
    method: 'post',
    data: data
  })
}

// 通过工作单UUID，获取舱单数据格式化详情
export function getManifestInfoDetailsByJobUuid(data) {
  return request({
    url: URL.seaExport.getManifestInfoDetailsByJobUuid,
    method: 'post',
    data: data
  })
}

// 获取舱单格式化信息
export function getManifestInfo(params) {
  return request({
    url: URL.seaExport.getManifestInfo,
    method: 'get',
    params
  })
}
// 获取舱单格式化信息列表
export function getManifestInfos(data) {
  return request({
    url: URL.seaExport.getManifestInfos,
    method: 'post',
    data
  })
}

// 舱单格式化货物信息
export function getManifestGoods(params) {
  return request({
    url: URL.seaExport.getManifestGoods,
    method: 'get',
    params
  })
}

// 舱单格式化VGM信息
export function getManifestVGMs(params) {
  return request({
    url: URL.seaExport.getManifestVGMs,
    method: 'get',
    params
  })
}

// 获取预配舱单基本信息
export function getManifestInfoBaseOneByJobId(params) {
  return request({
    url: URL.seaExport.getManifestInfoBaseOneByJobId,
    method: 'get',
    params
  })
}

// 发送荣e通舱单
export function sendRongeTongKeeper(data) {
  return request({
    url: URL.seaExport.sendRongeTongKeeper,
    method: 'post',
    data
  })
}

// 更新荣e通舱单
export function updateRongeTongKeeper(data) {
  return request({
    url: URL.seaExport.updateRongeTongKeeper,
    method: 'post',
    data
  })
}

// 删除荣e通舱单
export function deleteRongeTongKeeper(data) {
  return request({
    url: URL.seaExport.deleteRongeTongKeeper,
    method: 'post',
    data
  })
}

// 荣e通舱单改配接口
export function updateRongeTongManifestConfig(data) {
  return request({
    url: URL.seaExport.updateRongeTongManifestConfig,
    method: 'post',
    data
  })
}

// 发送未斯舱单
export function sendWseKeeper(data) {
  return request({
    url: URL.seaExport.sendWseKeeper,
    method: 'post',
    data
  })
}

// 更新未斯舱单
export function updateWseKeeper(data) {
  return request({
    url: URL.seaExport.updateWseKeeper,
    method: 'post',
    data
  })
}

// 删除未斯舱单
export function deleteWseKeeper(data) {
  return request({
    url: URL.seaExport.deleteWseKeeper,
    method: 'post',
    data
  })
}

// 发送海管家舱单
export function sendSeaHousekeeper(data) {
  return request({
    url: URL.seaExport.sendSeaHousekeeper,
    method: 'post',
    data
  })
}

// 更新海管家舱单
export function updateSeaHousekeeper(data) {
  return request({
    url: URL.seaExport.updateSeaHousekeeper,
    method: 'post',
    data
  })
}

// 删除海管家舱单
export function deleteSeaHousekeeper(data) {
  return request({
    url: URL.seaExport.deleteSeaHousekeeper,
    method: 'post',
    data
  })
}
// 撤销海管家舱单
export function cancelSeaHousekeeper(data) {
  return request({
    url: URL.seaExport.cancelSeaHousekeeper,
    method: 'post',
    data
  })
}

// 复制舱单链接
export function generateCfmManifestURL(params) {
  return request({
    url: URL.seaExport.generateCfmManifestURL,
    method: 'get',
    params
  })
}

// 复制舱单链接(公共)
export function generateShareCfmManifestURL() {
  return request({
    url: URL.seaExport.generateShareCfmManifestURL,
    method: 'get'
  })
}

// 查询舱单数据格式化CFM日志
export function queryManifestCfmLog(params) {
  return request({
    url: URL.seaExport.queryManifestCfmLog,
    method: 'get',
    params
  })
}

// 舱单数据格式化状态修改
export function modifyManifestState(params) {
  return request({
    url: URL.seaExport.modifyManifestState,
    method: 'post',
    params
  })
}

// 保存舱单数据格式化及关联信息
export function saveManifestRelatedInfo(data) {
  return request({
    url: URL.seaExport.saveManifestRelatedInfo,
    method: 'post',
    data
  })
}

// 补充邀请舱单
export function sendCfmManifestEmail(data, params) {
  return request({
    url: URL.seaExport.sendCfmManifestEmail,
    method: 'post',
    data,
    params
  })
}

// 补充邀请舱单(公共)
export function sendShareCfmManifestEmail(params) {
  return request({
    url: URL.seaExport.sendShareCfmManifestEmail,
    method: 'post',
    params
  })
}

// 确认预配信息
export function confirmManifest(params) {
  return request({
    url: URL.seaExport.confirmManifest,
    method: 'post',
    params
  })
}

// 确认预配信息
export function synchronousManifest(params) {
  return request({
    url: URL.seaExport.synchronousManifest,
    method: 'post',
    params
  })
}
// 确认预配信息
export function synchronizationGoodsInfo(params) {
  return request({
    url: URL.seaExport.synchronizationGoodsInfo,
    method: 'get',
    params
  })
}

// 验证是否发送过EDI
export function checkSendEDI(params) {
  return request({
    url: URL.seaExport.checkSendEDI,
    method: 'post',
    params
  })
}

export function exportSinO56TemplateNb(data) {
  return request({
    url: URL.seaExport.exportSinO56TemplateNb,
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 作废舱单
export function invalidManifest(params) {
  return request({
    url: URL.seaExport.invalidManifest,
    method: 'post',
    params
  })
}

// 获取海管家船代信息
export function getShipAgent(data) {
  return request({
    url: URL.seaExport.getShipAgent,
    method: 'post',
    data
  })
}

// 获取未斯船代信息
export function getWseShipAgent(data) {
  return request({
    url: URL.seaExport.getWseShipAgent,
    method: 'post',
    data
  })
}

// 获取荣e通船代信息
export function getRongeTongShipAgent(data) {
  return request({
    url: URL.seaExport.getRongeTongShipAgent,
    method: 'post',
    data
  })
}

// 获取海管家服务指南url
export function getUrl() {
  return request({
    url: URL.seaExport.convertSeaHouseInnerUrl,
    method: 'get'
  })
}

export function updateManifestStatus(data) {
  return request({
    url: URL.seaExport.updateManifestStatus,
    method: 'post',
    data
  })
}
